/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actual_SetpointInputs */



/**
* | output |
* | --- |
* | "Applied setpoint" |
*
* @param {Actual_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actual_setpoint = /** @type {((inputs?: Actual_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actual_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Applied setpoint")
	return /** @type {LocalizedString} */ ("Consigne appliquée")
});